import React from 'react';
import { Button } from 'primereact/button';
import '../../../assets/css/teacherMaster.css';
import userImage from '../../../assets/images/UserImage.png';
import { useNavigate } from 'react-router-dom';
import { apiBase } from '../../../utils/config';
import { InputSwitch } from 'primereact/inputswitch';
import { Checkbox } from 'primereact/checkbox';

const ParentCard = ({ parent, handleDelete, toggleActiveStatus, handlePassword, AccessList, selectedParents, onSelectParent, pageAccess }) => {
    const navigate = useNavigate();
    return (
        <div className="teacher-card">
            <img src={parent?.ProfilePhotoUrl ? `${apiBase}/UserProfilePic/${parent?.ProfilePhotoUrl}` : userImage} alt='' className="teacher-image" />
            <h4 className='p-m-0'>{parent?.Name}</h4>
            <p className='p-m-0'>{parent?.Status}</p>
            <div className="p-d-flex p-ai-center p-jc-center masters-switch">
                {pageAccess?.DeleteAccess &&
                    <Checkbox
                        inputId={`select-${parent?._id}`}
                        checked={Array.isArray(selectedParents) && selectedParents.some(s => s?._id === parent?._id)}
                        onClick={() => onSelectParent(parent)}
                        className='p-mr-2'
                    />}
                {pageAccess?.ViewAccess &&
                    <Button icon="icon-view tailer-icon" className='e-sction-btn p-m-0' onClick={() => navigate('/viewEdit-parent-master', { state: { userId: parent?._id, isEdit: false } })} />}
                {pageAccess?.EditAccess && <Button icon="pi pi-pencil" className='e-sction-btn p-ml-2 p-mr-0' onClick={() => navigate('/viewEdit-parent-master', { state: { userId: parent?._id, isEdit: true } })} />}
                {pageAccess?.DeleteAccess && <Button icon="pi pi-trash" className="e-sction-btn p-mr-1 p-ml-2" onClick={(e) => handleDelete(parent?._id)} />}
                {pageAccess?.EditAccess && (
                    <>
                        <InputSwitch
                            checked={parent?.Status === 'Active' ? true : false}
                            onChange={(e) => {
                                toggleActiveStatus(parent._id, e.value);
                            }}
                            className="p-ml-1 p-mt-1"
                        />
                        {parent?.Phone && AccessList?.IsParent &&
                            <Button icon="pi pi-key" className="e-sction-btn p-my-0 p-mr-0 p-ml-2" onClick={(e) => handlePassword(parent?._id)} />}
                    </>)}
            </div>
        </div>
    );
}

export default ParentCard;
